module.exports = "../content/c0844c990ecaaeb9f124758d38df4f3f.ttf";